/* Which sign-up backend the flow uses: the API, or one injected with <WelcomeBackendProvider> (tests). */
import { createContext, useContext, type ReactNode } from 'react';
import { httpWelcome, type WelcomeBackend } from './client';

const Ctx = createContext<WelcomeBackend | null>(null);

export function WelcomeBackendProvider({ value, children }: { value: WelcomeBackend; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useWelcomeBackend(): WelcomeBackend {
  return useContext(Ctx) ?? httpWelcome;
}
